import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaInputDirective } from '@global-front-components/ui/input';
import { CaFormFieldComponent, CaHint, CaLabel } from '@global-front-components/ui/form-field';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { CaButtonComponent } from '@global-front-components/ui/button';

@Component({
	selector: 'app-recuperar-proyecto',
	standalone: true,
	imports: [
		CommonModule,
		CaInputDirective,
		CaFormFieldComponent,
		ReactiveFormsModule,
		CaLabel,
		CaHint,
		TranslateModule,
		CaButtonComponent
	],
	templateUrl: './recuperar-proyecto.component.html',
	styleUrls: ['./recuperar-proyecto.component.scss']
})
export class RecuperarProyectoComponent implements OnInit, OnDestroy{
	public recuperarProyForm: FormGroup;
	
	constructor(
			private formBuilder: FormBuilder,
			private router: Router
	) { }

	ngOnDestroy(): void {
		this.recuperarProyForm?.reset(); 
	}

	ngOnInit(): void {
		this.recuperarProyForm = this.formBuilder.group({idPropuesta: ['',[Validators.required]]});
	}

	recuperar() {
		if (this.recuperarProyForm.invalid) {
			return;
		}
		this.router.navigate(['/autos/tarificar'], { queryParams: { idPropuesta: this.recuperarProyForm.get('idPropuesta').value } });
	}
}
